import { createAsyncThunk } from "@reduxjs/toolkit";
import type {
  OperatorBookingSettingsRequest,
  OperatorBookingSettingsResponse,
} from "api-client";
import { rejectMessage } from "api-client";
import {
  OPERATOR_BOOKING_SETTINGS_OPERATOR_ID,
  operatorBookingSettingsService,
} from "../../services/operator-booking-settings.service";

export const fetchBookingSettings = createAsyncThunk<
  OperatorBookingSettingsResponse,
  number | undefined,
  { rejectValue: string }
>("bookingSettings/fetch", async (operatorId, { rejectWithValue }) => {
  try {
    return await operatorBookingSettingsService.getBookingSettings(
      operatorId ?? OPERATOR_BOOKING_SETTINGS_OPERATOR_ID,
    );
  } catch (e: unknown) {
    return rejectWithValue(rejectMessage(e, "Failed to load booking settings"));
  }
});

export const saveBookingSettings = createAsyncThunk<
  OperatorBookingSettingsResponse,
  { operatorId?: number; body: OperatorBookingSettingsRequest },
  { rejectValue: string }
>("bookingSettings/save", async ({ operatorId, body }, { rejectWithValue }) => {
  try {
    return await operatorBookingSettingsService.saveBookingSettings(
      operatorId ?? OPERATOR_BOOKING_SETTINGS_OPERATOR_ID,
      body,
    );
  } catch (e: unknown) {
    return rejectWithValue(rejectMessage(e, "Failed to save booking settings"));
  }
});
